export default $axios => ({
    getOptions() {
        return $axios({
            method: 'GET',
            url: '/calculator/credit-calculator/'
        });
    },
    getFilials() {
        return $axios({
            method: 'GET',
            url: '/calculator/filials/'
        });
    },
    calculation(data) {
        return $axios({
            method: 'POST',
            url: '/calculator/credit-price/',
            data: data
        });
    },
    sendRequest(data) {
        return $axios({
            method: 'POST',
            url: '/calculator/credit-request/',
            data: data
        });
    }
});
